// Module
var code = "<" + "script id=\"koOGStkBrkHdr\" type=\"text/html\"> <" + "/script> <" + "script id=\"koOGStkBrk\" type=\"text/html\"> <" + "/script> ";
// Exports
export default code;